<template>
  <div>
    <div class="petDetails">
      <v-header :goBack="true" :mine='true' ref="headerHei"></v-header>
      <div class="title" ref="title">{{$t('petDetails.find')}}</div>
      <div class="main" ref="wrapper" >
        <scroller
          :on-refresh="refresh"
          :on-infinite="infinite"
          ref="scriller"
          :refreshText="$t('finder.pullRefresh')"
          :noDataText="pageComment"
          >
        <div ref="wrapperChild" class="wrapperChild" style="height: 320px;">
          <!-- <div class="main-head">
            {{$t('petDetails.findInfo')}}
            <span @click="modalOpen">
              <img src="../../image/share.png" alt>
            </span>
          </div> -->
          
          <div class="main-body" ref="findnews">
            <!-- <div class="container-head">{{petInfo.title}}</div> -->
            <div class="headPortrait">
              <div><img :src="petInfo.photoUrl" alt="portrait"></div>
              <p>{{petInfo.nickname}}</p>
            </div>
            <div class="container-status">
              <div class="losetime">
                <!-- <img src="../../image/time.png" alt> -->
                {{loseTime}}
              </div>
              <div class="read-status">
                <img src="../../image/read.png" alt>
                {{petInfo.readTimes}}
              </div>
              <div class="findState" v-if="petInfo.isOpen=='1'">{{$t('mysearch.finding')}}</div>
              <div class="findState" v-if="petInfo.isOpen=='2'">{{$t('mysearch.finded')}}</div>
              <div class="findState" v-if="petInfo.isOpen=='0'">{{$t('mysearch.closed')}}</div>
            </div>
            <div class="container-content">{{petInfo.content}}</div>
            <div class="pet_pics">
              <ul>
                <li v-for="(img,index) in featurePhoto" :key="index">
                  <img :src="img" alt="" @click="detailImg(img)">
                </li>
              </ul>
            </div>
            <div class="place">
              <img src="../../image/gps.png" alt="">
              {{lostPlace}}
            </div>
            <div class="container-contact">
              <div
                class="person"
              >{{$t('petDetails.relationPer')}}：{{petInfo.nickname?petInfo.nickname:notapply}}</div>
              <div
                class="phone"
              >{{$t('petDetails.relationWay')}}：{{petInfo.mobile&&petInfo.email?petInfo.mobile+'\n'+petInfo.email:petInfo.mobile && !petInfo.email?petInfo.mobile:!petInfo.mobile && petInfo.email?petInfo.email:nocontact}}</div>
            </div>
            <div class="petIntro" @click="intoPetinfo">{{$t('petDetails.petintro')}}<img src="../../image/toPetnews.png" alt=""/></div>
            <!-- <div class="swiperBox">
              <swiper :options="swiperOption">
                <swiper-slide v-for="(img,index) in featurePhoto" :key="index" ref="imgstyle">
                  <img :src="img" :onerror="errorImg" @click="detailImg(img)">
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
              </swiper>
            </div> -->
          </div>
          <!-- <div class="recommend" v-if="relHelpList.length!=0"> -->
          <div class="recommend" v-if="false">
            <div class="container-head">{{$t('petDetails.relHelp')}}</div>
            <div class="rec-help">
              <ul class="relBox">
                <!-- <li v-for="(item,index) in relHelpList" :key='index' @click="intoRelHelp(item.id)"><img :src="item.firstPhoto" alt=""></li> -->
                <li @click="relHelpList[0]?intoRelHelp(relHelpList[0].id):''">
                  <img :src="relHelpList[0]?relHelpList[0].firstPhoto:''" :onerror="errorImg1" alt>
                </li>
                <li @click="relHelpList[1]?intoRelHelp(relHelpList[1].id):''">
                  <img :src="relHelpList[1]?relHelpList[1].firstPhoto:''" :onerror="errorImg1" alt>
                </li>
                <li @click="relHelpList[2]?intoRelHelp(relHelpList[2].id):''">
                  <img :src="relHelpList[2]?relHelpList[2].firstPhoto:''" :onerror="errorImg1" alt>
                </li>
              </ul>
            </div>
          </div>
          <div class="comments" ref="comments">
            <div class="comments_title"><span>{{$t('finder.comments')}}</span></div>
            <div class="comments_list" ref="commentsList">
              <ul>
                <li v-for="(comment,index) in commentsList" :key="index" v-if="comment.content!=''">
                  <div class="user_news">
                    <img :src="comment.pic" alt=""><span>{{comment.nickname}}</span><b>2019-05-27</b>
                  </div>
                  <div class="user_coms">
                    {{comment.content}}
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        </scroller>
      </div>
    </div>
    <!-- 发表评论 -->
    <div class='add_comment' ref="addCom">
      <el-input :placeholder="$t('forgetpassword.sendContent2')" v-model="addContent"></el-input>
      <el-button @click="addComments">{{$t('forgetpassword.sendcode2')}}</el-button>
    </div>
    <!-- 模态框 -->
    <transition name="fade">
      <div class="modal" v-if="modalStatus">
        <div class="modalBox" @click.stop="modalClose">
          <div class="shareBox" @click.stop>
            <div style="padding:0px 10px;">
              <div class="shareTitle">
                <span>{{$t('petDetails.share')}}</span>
              </div>
              <div class="shareList">
                <div @click="call('wechatTimeline')">
                  <img src="../../image/share-wechat.png" alt>
                </div>
                <div @click="call('qqFriend')">
                  <img src="../../image/share-qq.png" alt>
                </div>
                <div @click="call('weibo')">
                  <img src="../../image/share-sine.png" alt>
                </div>
                <div>
                  <facebook :url="currentHref" :title="shareTitle" scale="3"></facebook>
                </div>
                <!-- <div @click="call()">
                                    <img src="../../image/share-facebook.png" alt="">
                </div>-->
                <div>
                  <twitter :url="currentHref" :title="shareTitle" scale="3"></twitter>
                </div>
              </div>
            </div>
            <button class="cancelShare" @click="modalClose">{{$t('petDetails.cancelshare')}}</button>
          </div>
        </div>
      </div>
    </transition>
    <div class="modal-share" v-if="wechatmodal" @click="sharemodalClose">
      <img class="shareModel" src="../../image/shareSign.png">
    </div>
    <transition name="fade">
      <div class="modal-img" v-if="imgModal" @click="imgModal=false">
        <div>
          <img :src="currentImg" alt :onerror="errorImg">
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import IScroll from "iscroll/build/iscroll-probe";
import header from "../../components/header";
import {
  addReadTimes,
  getPublish,
  getRecommend
} from "../../ClientServerApi/index.js";
import {getComment, addComment} from "../../apiNew/index.js"
import Qs from "qs";
import { Facebook, Twitter } from "vue-socialmedia-share";

export default {
  name: "petDetails",
  inject: ["reload"],
  data() {
    return {
      pageComment:'',
      currentImg: "",
      imgModal: false,
      notapply: this.$t("prompt.notapply"),
      nocontact: this.$t("prompt.nocontact"),
      errorImg: 'this.src="' + require("../../assets/errorimg.png") + '"',
      errorImg1: 'this.src="' + require("../../assets/errorimg1.jpg") + '"',
      modalStatus: false,
      wechatmodal: false,
      publishId: "",
      shareTitle: "",
      currentHref: window.location.href,
      readTimes: "0",
      petInfo: "",
      featurePhoto: "",
      relatedHelp: {},
      relHelpList: "",
      loseTime: "",
      lostPlace: "",
      noHelp: 'this.src="' + require("../../image/nohelp.jpg") + '"',
      topicID:'',
      addContent:'',
      commentsList:[],
      page:0,
      size:5,
      pageover: false,
      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
          type: "bullets"
        },
        paginationClickable: true,
        autoplay: false,
        // height: window.innerHeight,
        autoHeight: true,
        mousewheel: true,
        autoplayDisableOnInteraction: false,
        loop: false,
        coverflow: {
          rotate: 30,
          stretch: 10,
          depth: 60,
          modifier: 2,
          slideShadows: true
        }
      }
    }; 
  },
  created() {
    this.$nextTick(() => {
      this.Scroll = new IScroll(this.$refs.wrapper, {
        click: true
      });
      if (sessionStorage.getItem("login")) {
        this.loginsuccess = true;
        this.loginshowflag = false;
      }
    });
    this.publishId = Qs.stringify({ publishId: this.$route.query.id });
    this.topicID = this.$route.query.id;
    let params = this.publishId;
    addReadTimes(params) //点击储存用户浏览量
      .then(res => {
        if (res.data.header.status == 1000) {
          this.readTimes = res.data.data.readTimes;
        }
      })
      .catch(err => {});
    this.getPublishDetail(this.publishId);
  },
  mounted() {
    // console.log(this.currentHref)
    this.$refs.wrapper.style.height = 
    document.documentElement.clientHeight - this.$refs.title.offsetHeight
    -this.$refs.addCom.offsetHeight - this.$refs.headerHei.offsetHeight+'px'
    // console.log(this.$refs.wrapper.style.height)
    // this.$nextTick(() => {
    //   console.log(this.$refs.wrapperChild.offsetHeight);
    // });
    // this.$refs.wrapperChild.style.height='1200px';

    // this.$refs.wrapperChild.style.height = "auto";
    //  console.log(this.$refs.wrapperChild.offsetHeight);
     this.$refs.wrapper.style.top = 90 + this.$refs.title.offsetHeight + "px";
     this.getComments()
  },
  methods: {
    detailImg(img) {
      //点击浏览放大后的图片
      this.currentImg = img;
      this.imgModal = true;
      // console.log(img);
    },
    back() {
      this.$router.replace("/finder");
    },
    getPublishDetail(params) {
      getPublish(params).then(res => {
        //获得协寻详情
        // console.log("获得协寻详情",res)
        if (res.data.header.status == 1000) {
          this.petInfo = res.data.data;
          // console.log('getNews:',this.petInfo)
          this.lostPlace = this.petInfo.lostPlace;
          // console.log(JSON.parse(this.petInfo.featurePhoto)[0])
          this.shareTitle = res.data.data.title;
          this.loseTime = this.petInfo.loseTime.slice(0, 10);
          this.relatedHelp.lat = this.petInfo.lat;
          this.relatedHelp.lon = this.petInfo.lon;
          this.relatedHelp.publishId = this.petInfo.publishId;
          this.featurePhoto = JSON.parse(res.data.data.featurePhoto);
          this.topicID = this.petInfo.publishId
          // console.log(this.topicID)
        //   let params = Qs.stringify({
        //     lat: this.relatedHelp.lat,
        //     lon: this.relatedHelp.lon,
        //     publishId: this.relatedHelp.publishId
        //   });
        //   getRecommend(params)
        //     .then(res => {
        //       //相关推荐
        //       if (res.data.header.status == 1000) {
        //         this.relHelpList = res.data.data;
        //       }
        //     })
        //     .catch(err => {});
        }
      });
    },
    //分页
    refresh(done){
      let that = this
      setTimeout(() => {
        that.reload();
      }, 1500);
    },
    //加载
    infinite(done){
      let that = this
      setTimeout(() => {
        if(this.pageover== false){
          that.page++
          that.getComments()
        }else{
          done(true);
        }
      }, 1500);
    },
    //获取评论
    getComments(){
      // console.log(this.topicID)
      let params=Qs.stringify({
        topicID:this.topicID,
        page:this.page,
        size:this.size
      });
      getComment(params)
      .then(res=>{
        // console.log("获取评论：",res.data.data)
        if(res.data.header.status==1000){
          if(this.commentsList.length==0&&res.data.data.length==0){
            this.pageover = true;
            this.pageComment = this.$t('finder.noComment')
            let that = this;
            that.$refs.wrapperChild.style.height = that.$refs.findnews.offsetHeight+ 200 + that.$refs.comments.offsetHeight+'px';
          }else{
            this.pageover = false;
            if(this.commentsList.length==0){
              this.commentsList = res.data.data;
            }else if(res.data.data.length==5){
              let addlist = this.commentsList;
              this.commentsList = addlist.concat(res.data.data)
            }else if(res.data.data.length>0&&res.data.data.length<5){
              let addlist = this.commentsList;
              this.commentsList = addlist.concat(res.data.data)
              this.pageover = true;
              this.pageComment = this.$t('finder.noMoreComment')
            }else if(res.data.data.length==0){
              this.pageover = true;
              this.pageComment = this.$t('finder.noMoreComment')
            }
            let that = this;
            that.$refs.wrapperChild.style.height = that.$refs.findnews.offsetHeight+ 52 + that.$refs.comments.offsetHeight+'px';
          }
          this.$refs.scriller.finishInfinite();
        }
        if(res.data.header.status==3005){
          this.pageover = true;
          this.pageComment = this.$t('finder.notAccount')
          let that = this;
          that.$refs.wrapperChild.style.height = that.$refs.findnews.offsetHeight+100 + that.$refs.comments.offsetHeight+'px';
          this.$refs.scriller.finishInfinite();
        }
      })
      .catch(err=>{
        console.log(err)
      })
      // let that = this;
      // that.$refs.wrapperChild.style.height = that.$refs.findnews.offsetHeight+100 + that.$refs.comments.offsetHeight+'px';
      // console.log(that.$refs.findnews.offsetHeight+100)
      // console.log(that.$refs.commentsList.offsetHeight)
      // console.log(that.$refs.comments.offsetHeight)
      // console.log(that.$refs.wrapperChild.style.height)
    },
    //增加评论
    addComments(){
      // console.log(this.topicID)
      if(this.addContent==''){
        this.$alert(this.$t('finder.enterComment'))
      }else{
        let params = Qs.stringify({
          topicID: this.topicID,
          content: this.addContent
        });
        addComment(params)
        .then(res=>{
          // console.log(res.data.header.status)
          // console.log('增加评论')
          if(res.data.header.status==1000){
            this.addContent = '';
            this.getComments()
          }
        })
        .catch(err=>{

        })
      }

    },
    intoPetinfo() {
      //宠物介绍
      this.$router.push({
        name: "findPetInfo",
        query: { petInfo: JSON.stringify(this.petInfo) }
      });
    },
    modalOpen() {
      //打开模态框
      this.modalStatus = true;
    },
    modalClose() {
      //关闭模态框
      this.modalStatus = false;
    },
    sharemodalClose() {
      this.wechatmodal = false;
    },
    call(plat) {
      var ua = navigator.userAgent.toLowerCase();//判断浏览器的类型并转行成小写
      var isWeixin = ua.indexOf("micromessenger") != -1;
      if (isWeixin) {
        // 这是微信浏览
        this.wechatmodal = true;
      } else {
        let nativeShare = new NativeShare();
        let shareData = {
          title: this.petInfo.title,
          desc: this.petInfo.content,
          // 如果是微信该link的域名必须要在微信后台配置的安全域名之内的。
          link: this.currentHref,
          icon: this.petInfo.featurePhoto,
          // 不要过于依赖以下两个回调，很多浏览器是不支持的
          success: function() {
            alert("success");
          },
          fail: function() {
            alert("fail");
          }                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        
        };
       
        try {
          nativeShare.call(plat);
        } catch (err) {
          // 如果不支持，你可以在这里做降级处理
          alert(this.$t('prompt.noApply'))
        }
      }
    },
    intoRelHelp(id) {
      //点击相关协寻
      this.$router.push({ name: "petDetails", query: { id: id } });
      
    }
  
  },

  watch: {
    $route(to, from) {
      // console.log(to, from);
      this.reload();
    }
  },

  components: {
    "v-header": header,
    Facebook,
    Twitter
  }
};
</script>
<style>
.add_comment .el-input .el-input__inner{
  border: 0;
}
/* .petDetails ._v-container>._v-content>.loading-layer>.no-data-text{
  top: 55px;
} */
</style>

<style scoped>
.petDetails {
  background-color: #fff;
}
.main {
  /* padding: 0 10px; */
  overflow: hidden;
  position: absolute;
  bottom: 0;
  padding-bottom: 60px;
  width: 100%;
  /* max-width: 720px; */
  touch-action: none;
  box-sizing: border-box;
}
.place {
  font-size: 0.8rem;
  padding: 0 1rem 1rem 4rem;
  color: #646464;
}
.place img{
  width: 1rem;
}
.shareModel {
  width: 100%;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.title {
  text-align: center;
  color: #828282;
  font-size: 1rem;
  background-color: #fff;
  margin: 20px 0;
}
.main-head {
  padding: 10px 0;
  text-align: center;
  font-size: 0.8rem;
  border-bottom: 1px solid #e6e6e6;
}
.main-head span {
  float: right;
}

.main-head img {
  width: 1.2rem;
  height: 1.2rem;
  vertical-align: middle;
}
/* .container-head {
  font-size: 1rem;
  padding: 15px 0;
} */
.headPortrait{
  width: 100%;
  display: inline-flex;
  justify-content: flex-start;
}
/* .headPortrait::after{
  width: 100%;
  height: 0;
  clear: both;
  content: '';
} */
.headPortrait div{
  width: 2.5rem;
  height: 2.5rem;
  line-height: 2.5rem;
  border-radius: 50%;
  overflow: hidden;
  text-align: center;
  margin: 0 0.5rem;
}
.headPortrait div img{
  width: 2.5rem;
  height: 2.5rem;
  vertical-align: middle;
}
.headPortrait p{
  font-size: 0.9rem;
  line-height: 2.5rem;
}
.container-status {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  align-items: center;
  padding: 0 1rem 0 3.5rem;
}
.container-status .read-status {
  flex: 6;
  font-size: 0.8rem;
  color: #afafaf;
  margin-right: 20px;
}
.container-status .losetime {
  flex: 10;
  font-size: 0.8rem;
  color: #afafaf;
}
.container-status img {
  width: 1rem;
  vertical-align: middle;
  padding-right: 2px;
}
.container-status .findState {
  flex: 8;
  font-size: 0.85rem;
  text-align: right;
  color: #095196;
  text-decoration: underline;
}
.container-content {
  padding: 1rem 1rem 1rem 3.5rem;
  font-size: 0.8rem;
  line-height: 1.2rem;
  color: #828282;
  white-space:normal;
  word-break:break-all;
  word-wrap:break-word;
}
.pet_pics{
  width: 100%;
  box-sizing: border-box;
  padding: 0 1rem 1rem 3.5rem;
}
.pet_pics ul{
  width: 100%;
  display: inline-flex;
}
.pet_pics ul li{
  list-style: none;
  width: 33.33%;
  box-sizing: border-box;
  margin: 0 1%;
  height: 6rem;
  line-height: 6rem;
  overflow: hidden;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
.pet_pics ul li img{
  height: 6rem;
  /* vertical-align: middle; */
}
.container-contact {
  font-size: 0.8rem;
  color: #646464;
  padding: 0 1rem 1rem 3.5rem;
}
.container-contact .person {
  padding-bottom: 1rem;
}
.container-contact .phone {
  
}
.petIntro{
  font-size: 0.8rem;
  line-height: 1.6rem;
  padding: 0 1rem 1rem 3.5rem;
  color: #7dc3f2;
  border: 0;
  border-bottom: 1px solid #cccccc;
  box-shadow: 0px 6px 6px #eeeeee;
}
.petIntro img{
  width: 0.8rem;
  vertical-align: middle;
  margin-left: 5px;
}
.swiperBox {
  width: 100%;
  margin-top: 20px;
  overflow: hidden;
  text-align: center;
  /* height: 200px; */
}
.swiperBox img {
  width: 60%;
  vertical-align: middle;
  /* transform: translateY(-4rem);  */
}
.modal,
.modal-share,
.modal-img {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  transition: cubic-bezier(0.075, 0.82, 0.165, 1);
  top: 0;
  z-index: 100;
  line-height: 100%;
}

.modal-share {
  z-index: 1000;
}
.modalBox {
  width: 100%;
  height: 100%;
}
.modal-img {
  display: flex;
  transition: all 0.3s ease;
  align-items: center;
}
.modal-img div {
  margin: 0 auto;
  text-align: center;
  width: 80%;
}
.modal-img img {
  width: 100%;
}
.shareBox {
  width: 100%;
  background-color: #fff;
  position: fixed;
  bottom: 0;
  box-sizing: border-box;
}
.shareTitle {
  text-align: center;
  padding: 20px 0;
  font-size: 0.5rem;
  position: relative;
  color: #666;
}
.shareTitle span {
  background-color: #fff;
  display: inline-block;
  padding: 0 10px;
}
.shareTitle ::before {
  content: "";
  display: inline-block;
  height: 1px;
  background-color: #eee;

  width: 50%;
  position: absolute;
  left: 0;
  z-index: -1000;
  top: 27px;
}
.shareTitle ::after {
  content: "";
  display: inline-block;
  height: 1px;
  background-color: #eee;
  width: 50%;
  position: absolute;
  right: 0;
  z-index: -1000;
  top: 27px;
}

.shareList {
  text-align: center;
  padding: 20px 0;
  padding-bottom: 60px;
}
.shareList::after {
  content: " ";
  display: block;
  clear: both;
}
.shareList img {
  width: 2.3rem;
  height: 3rem;
}
.shareList div {
  width: 20%;
  float: left;
}
.cancelShare {
  width: 100%;
  border: none;
  height: 40px;
  font-size: 0.6rem;
  background-color: #ececec;
}
.relBox {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
}
.relBox li {
  flex: 8;
  padding: 5px;
  width: 100%;
}
.relBox li img {
  width: 100%;
  height: 90px;
  border: 0;
  object-fit: cover;
}

.comments{
  width: 100%;
  border-top:1px solid #eeeeee; 
  padding-top: 1rem;
}
.comments_title{
  width: 100%;
  font-size: 1rem;
  line-height: 2.4rem;
}
.comments_title span{
  border-bottom: 2px solid #7dc3f2;
  margin-left: 0.5rem;
}
.comments_list{
  width: 100%;
  margin-top: 1rem;
}
.comments_list ul li{
  list-style: none;
  width: 100%;
  border-bottom: 1px solid #cccccc;
  margin-bottom: 1rem;
}
.user_news{
  width: 100%;
  height: 3rem;
  line-height: 3rem;
}
.user_news img{
  vertical-align: middle;
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  overflow: hidden;
  margin: 0 0.5rem;
}
.user_news b{
  float: right;
  margin-right: 0.5rem;
  color: #999999;
  font-size: 0.8rem;
  font-weight: 100;
}
.user_coms{
  width: 100%;
  box-sizing: border-box;
  padding: 0 0.5rem 1rem 4rem;
  text-align: justify;
  color: #999999;
  font-size: 0.8rem;
  line-height: 1.6rem;
}
.add_comment{
  position: fixed;
  bottom: 0px;
  width: 100%;
  background: #f5f5f5;
  box-sizing: border-box;
  padding: 0.6rem 0.8rem;
  display: inline-flex;
  justify-content: space-between;
}
.add_comment .el-button{
  margin-left: 0.5rem;
  color: #ffffff;
  background: #7dc3f2;
  border: 0;
}
/* .main{
  overflow: hidden;
  position: absolute;
  bottom: 40px;
  top: 55px;
  width: 100%;
  max-width: 579px;
  touch-action: none;} */
</style>


// WEBPACK FOOTER //
// src/m_page/finder/petDetails.vue